import { useEffect, useState } from "react";
import SideBar from "../../components/ThirdPartyDashboard/SideBar";
import "../../styles/ThirdParty/Evaluation.scss";
import { useNavigate } from "react-router-dom";
export default function Evaluation() {
  const navigate = useNavigate();
  const [questions, setQuestions] = useState([]);
  const [questionsModal, setQuestionsModal] = useState(false);
  const [evaluationDoneModal, setEvaluationDoneModal] = useState(false);
  const list = [
    {
      question: "Why is GHG verification important for carbon projects?",
      options: [
        "To increase the overall carbon emissions",
        "To ensure the accuracy and credibility of reported emissions reductions",
        "To make the verification process more complex",
        "To avoid any form of regulation",
      ],
      answer:
        "To ensure the accuracy and credibility of reported emissions reductions",
    },
    {
      question:
        "What is one of the primary benefits of GHG verification for companies?",
      options: [
        "It allows companies to ignore emissions data",
        "It helps companies gain market trust and potentially access carbon credits",
        "It increases operational costs without any benefits",
        "It complicates compliance with environmental regulations",
      ],
      answer:
        "It helps companies gain market trust and potentially access carbon credits",
    },
    {
      question: "How does GHG verification affect stakeholder confidence?",
      options: [
        "Reduces transparency and trust in reported data",
        "Increases confidence by providing reliable and verified emissions data",
        "Has no impact on stakeholder confidence",
        "Only benefits the internal management of the company",
      ],
      answer:
        "Increases confidence by providing reliable and verified emissions data",
    },
    {
      question:
        "What does the principle of accuracy in GHG verification emphasize?",
      options: [
        "Reporting estimates without any validation",
        "Using outdated data for reports",
        "Ensuring that emissions data is as precise and accurate as possible",
        "Ignoring minor discrepancies in data",
      ],
      answer:
        "Ensuring that emissions data is as precise and accurate as possible",
    },
    {
      question:
        "What is the difference between carbon emissions and carbon sequestration?",
      options: [
        "Carbon emissions involve the absorption of CO2, while carbon sequestration involves the release of CO2.",
        "Carbon emissions refer to the release of CO2 into the atmosphere, while carbon sequestration refers to the absorption and storage of CO2.",
        "Carbon emissions and carbon sequestration are the same processes.",
        "Carbon emissions are always beneficial, while carbon sequestration is harmful.",
      ],
      answer:
        "Carbon emissions refer to the release of CO2 into the atmosphere, while carbon sequestration refers to the absorption and storage of CO2.",
    },
    {
      question:
        "What are the primary sources of carbon emissions that IoT devices on our platform might measure?",
      options: [
        "Solar panels and wind turbines",
        "Fossil fuel combustion and power generation",
        "Rainwater harvesting systems",
        "Electric vehicles and renewable energy sources",
      ],
      answer: "Fossil fuel combustion and power generation",
    },
    {
      question: "What is the importance of transparency in GHG verification?",
      options: [
        "To hide the verification methods from stakeholders",
        "To reduce the amount of information shared with the public",
        "To complicate the verification process",
        "To ensure all methods, data sources, and assumptions are clearly documented and accessible",
      ],
      answer:
        "To ensure all methods, data sources, and assumptions are clearly documented and accessible",
    },
    {
      question: "Why is consistency crucial in GHG verification?",
      options: [
        "To allow for random changes in methodology each year",
        "To ensure that emissions data is comparable over time",
        "To avoid using the same data sources repeatedly",
        "To decrease the reliability of data",
      ],
      answer: "To ensure that emissions data is comparable over time",
    },
    {
      question:
        "Which of the following is a key documentation requirement in GHG verification?",
      options: [
        "Keeping all data sources confidential",
        "Clearly documenting all data sources, methods, and assumptions used",
        "Avoiding the documentation of any data assumptions",
        "Using undocumented methods for data collection",
      ],
      answer:
        "Clearly documenting all data sources, methods, and assumptions used",
    },
    {
      question:
        "Why is third-party verification important in the GHG verification process?",
      options: [
        "To provide an independent assessment of the data's accuracy and reliability",
        "To allow internal staff to validate their own data",
        "To increase the complexity of the verification process",
        "To reduce the need for accurate data collection",
      ],
      answer:
        "To provide an independent assessment of the data's accuracy and reliability",
    },
    {
      question:
        "What does the principle of conservativeness ensure in GHG verification?",
      options: [
        "Overestimating emissions reductions",
        "Ensuring that uncertainties do not lead to an overestimation of emissions reductions",
        "Ignoring any potential uncertainties",
        "Reporting the maximum possible emissions reductions",
      ],
      answer:
        "Ensuring that uncertainties do not lead to an overestimation of emissions reductions",
    },
    {
      question:
        "Which of the following is a primary source of greenhouse gas emissions?",
      options: [
        "Solar power generation",
        "Fossil fuel combustion",
        "Wind power generation",
        "Hydroelectric power generation",
      ],
      answer: "Fossil fuel combustion",
    },
    {
      question: "What is the first step in collecting GHG data?",
      options: [
        "Data analysis",
        "Data verification",
        "Data reporting",
        "Data collection planning",
      ],
      answer: "Data collection planning",
    },
    {
      question:
        "Which step involves using sensors and meters to gather GHG emissions data?",
      options: [
        "Data analysis",
        "Data monitoring and measuring",
        "Data reporting",
        "Data verification",
      ],
      answer: "Data monitoring and measuring",
    },
    {
      question:
        "How would you verify the accuracy of emissions data provided by an IoT device?",
      options: [
        "By comparing it with historical data and cross-referencing with other data sources",
        "By assuming the data is always accurate",
        "By ignoring any anomalies in the data",
        "By manually recalculating the data",
      ],
      answer:
        "By comparing it with historical data and cross-referencing with other data sources",
    },
    {
      question: "What is an example of direct measurement of GHG emissions?",
      options: [
        "Using emission factors",
        "Estimating based on energy consumption",
        "Using CO2 sensors to measure emissions directly",
        "Calculating emissions from product usage",
      ],
      answer: "Using CO2 sensors to measure emissions directly",
    },
    {
      question:
        "Which of the following is an example of an indirect data source for GHG emissions?",
      options: [
        "Fuel consumption records",
        "Direct CO2 measurements",
        "Methane emissions from livestock",
        "Ambient air quality measurements",
      ],
      answer: "Fuel consumption records",
    },
    {
      question:
        "You are verifying a report claiming a 20% reduction in emissions over the past year, but external data sources do not corroborate this reduction. How would you proceed?",
      options: [
        "Investigate the discrepancies by comparing methods, checking data sources, and consulting with project stakeholders",
        "Accept the report without question",
        "Reject the report immediately",
        "Adjust the external data to match the report",
      ],
      answer:
        "Investigate the discrepancies by comparing methods, checking data sources, and consulting with project stakeholders",
    },
    {
      question:
        "What are the key regulatory standards and guidelines that govern the verification of emissions data?",
      options: [
        "ISO 14064, GHG Protocol, and relevant national regulations",
        "Only company policies",
        "No standards are required",
        "ISO 17029",
      ],
      answer: "ISO 14064, GHG Protocol, and relevant national regulations",
    },
    {
      question:
        "How do international standards (e.g., ISO 14064) influence the verification process on our platform?",
      options: [
        "They provide guidelines for accurate and consistent measurement, reporting, and verification of emissions",
        "They are irrelevant to the process",
        "They complicate the verification process without benefits",
        "They only apply to large corporations",
      ],
      answer:
        "They provide guidelines for accurate and consistent measurement, reporting, and verification of emissions",
    },
    {
      question:
        "Describe an ethical dilemma you might encounter during the verification process and how you would resolve it.",
      options: [
        "Conflict of interest with project owners; resolve by maintaining transparency and following standard procedures",
        "Ignoring data discrepancies to save time",
        "Favouring one stakeholder over others",
        "Reporting false data to meet targets",
      ],
      answer:
        "Conflict of interest with project owners; resolve by maintaining transparency and following standard procedures",
    },
    {
      question:
        "Why is impartiality important in the role of a verifier, and how can it be maintained?",
      options: [
        "Impartiality ensures unbiased and accurate verification; maintain it by adhering to standards and avoiding conflicts of interest",
        "Impartiality is not important",
        "Impartiality means supporting the company only",
        "Impartiality involves ignoring all standards",
      ],
      answer:
        "Impartiality ensures unbiased and accurate verification; maintain it by adhering to standards and avoiding conflicts of interest",
    },
    {
      question:
        "If a factory uses 10,000 liters of diesel with an emission factor of 2.68 kg CO2 per liter, what are the total CO2 emissions?",
      options: ["26,800 kg", "2,680 kg", "268 kg", "26,000 kg"],
      answer: "26,800 kg",
      type: "calculation",
    },
    {
      question:
        "An office building uses 50,000 kWh of electricity with an emission factor of 0.5 kg CO2 per kWh. What is the total CO2 emission?",
      options: ["25,000 kg", "50,000 kg", "75,000 kg", "100,000 kg"],
      answer: "25,000 kg",
      type: "calculation",
    },
    {
      question:
        "If the emission factor for a certain activity is 2.5 kg CO2 per unit activity and 100 units of the activity are performed, what is the total CO2 emission?",
      options: ["200 kg", "150 kg", "250 kg", "300 kg"],
      answer: "250 kg",
      type: "calculation",
    },
    {
      question:
        "If carbon credits are priced at $10 per ton of CO2 and a project reduces emissions by 25 tons, what is the total value of the carbon credits earned?",
      options: ["$250", "$500", "$150", "$100"],
      answer: "$250",
      type: "calculation",
    },
    {
      question:
        "A facility operates 12 hours a day, and the power production of its solar energy system is 2000 KWh. The facility used 1390 liters of diesel for its energy needs before switching to solar systems. What is the daily carbon emissions reduction of the facility? (E.F Diesel = 2.67 kg CO2/L)",
      options: [
        "2,780.30 kg CO2",
        "4,070.30 kg CO2",
        "3,711.30 kg CO2",
        "5,300.30 kg CO2",
      ],
      answer: "3,711.30 kg CO2",
      type: "calculation",
    },
  ];

  function getRandomQuestions(
    questionList,
    totalQuestions = 5,
    calculationQuestions = 2
  ) {
    // Separate calculation questions from the rest
    const calculationQs = questionList.filter((q) => q.type === "calculation");
    const otherQs = questionList.filter((q) => q.type !== "calculation");

    // Ensure we have enough questions of each type
    if (
      calculationQs.length < calculationQuestions ||
      otherQs.length < totalQuestions - calculationQuestions
    ) {
      throw new Error("Not enough questions of required types");
    }

    // Function to get random items from an array
    const getRandomItems = (arr, n) => {
      const shuffled = [...arr].sort(() => 0.5 - Math.random());
      return shuffled.slice(0, n);
    };

    // Get random calculation questions
    const selectedCalcQs = getRandomItems(calculationQs, calculationQuestions);

    // Get random other questions
    const selectedOtherQs = getRandomItems(
      otherQs,
      totalQuestions - calculationQuestions
    );

    // Combine and shuffle the selected questions
    return getRandomItems(
      [...selectedCalcQs, ...selectedOtherQs],
      totalQuestions
    );
  }

  const getQuestions = () => {
    const response = getRandomQuestions(list);
    console.log("getQuestions", response);

    setQuestions(response);
    setQuestionsModal(true);
  };

  const handleSelectOption = (option, question) => {
    console.log("option, question", option, question);
    let tempQuestions = questions;
    let tempQuestion = question;

    tempQuestion.selectedOption = option;

    tempQuestions.splice(questions?.indexOf(question), 1, tempQuestion);

    setQuestions([...tempQuestions]);
  };

  const handleSubmitTest = () => {
    const unansweredQuestions = questions.filter(
      (question) => !question?.selectedOption
    );
    if (unansweredQuestions?.length > 0) {
      alert("You have some unanswered questions");
      return;
    }
    let score = 0;
    for (let index = 0; index < questions.length; index++) {
      if (questions[index]?.selectedOption === questions[index]?.answer) {
        score++;
      }
    }
    alert(`Score: ${score}`)
    setEvaluationDoneModal(true);
  };

  const handleEvaluationModalClose = (e) => {
    if(e.target.classList.contains("evaluation__done")) {
setEvaluationDoneModal(false)
    }
  }

  return (
    <div className="evaluation">
      <div className="sidebar_container">
        <SideBar />
      </div>
      <div className="evaluation__main">
        <div className="evaluation__main__title">Welcome back, James</div>
        <div className="evaluation__main__subtitle">
          Let’s ensure accurate and sustainable carbon data.
        </div>
        <div className="evaluation__main__cards">
          <div className="evaluation__main__cards__title">
            Before you start verifying emission data, you need to pass a quick
            test. Here's what to do:
          </div>
          <div className="evaluation__main__cards__card evaluation__main__cards__card1">
            <div>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={{minWidth: "24px"}}
              >
                <path
                  d="M4.80039 6.59961C4.80039 6.44048 4.86361 6.28787 4.97613 6.17535C5.08865 6.06282 5.24126 5.99961 5.40039 5.99961H18.6004C18.7595 5.99961 18.9121 6.06282 19.0247 6.17535C19.1372 6.28787 19.2004 6.44048 19.2004 6.59961V10.1972C19.2004 10.3563 19.1372 10.509 19.0247 10.6215C18.9121 10.734 18.7595 10.7972 18.6004 10.7972H5.40039C5.24126 10.7972 5.08865 10.734 4.97613 10.6215C4.86361 10.509 4.80039 10.3563 4.80039 10.1972V6.59961ZM6.00039 7.19961V9.59721H18.0004V7.19961H6.00039ZM13.798 11.9996C13.6389 11.9996 13.4862 12.0628 13.3737 12.1753C13.2612 12.2879 13.198 12.4405 13.198 12.5996V17.3996C13.198 17.5587 13.2612 17.7114 13.3737 17.8239C13.4862 17.9364 13.6389 17.9996 13.798 17.9996H18.598C18.7571 17.9996 18.9097 17.9364 19.0223 17.8239C19.1348 17.7114 19.198 17.5587 19.198 17.3996V12.5996C19.198 12.4405 19.1348 12.2879 19.0223 12.1753C18.9097 12.0628 18.7571 11.9996 18.598 11.9996H13.798ZM14.398 16.7996V13.1996H17.998V16.7996H14.398ZM4.80039 13.1996C4.80039 13.0405 4.86361 12.8879 4.97613 12.7753C5.08865 12.6628 5.24126 12.5996 5.40039 12.5996H11.4052C11.5643 12.5996 11.7169 12.6628 11.8295 12.7753C11.942 12.8879 12.0052 13.0405 12.0052 13.1996C12.0052 13.3587 11.942 13.5114 11.8295 13.6239C11.7169 13.7364 11.5643 13.7996 11.4052 13.7996H5.40039C5.24126 13.7996 5.08865 13.7364 4.97613 13.6239C4.86361 13.5114 4.80039 13.3587 4.80039 13.1996ZM5.40039 16.1996C5.24126 16.1996 5.08865 16.2628 4.97613 16.3753C4.86361 16.4879 4.80039 16.6405 4.80039 16.7996C4.80039 16.9587 4.86361 17.1114 4.97613 17.2239C5.08865 17.3364 5.24126 17.3996 5.40039 17.3996H11.404C11.5631 17.3996 11.7157 17.3364 11.8283 17.2239C11.9408 17.1114 12.004 16.9587 12.004 16.7996C12.004 16.6405 11.9408 16.4879 11.8283 16.3753C11.7157 16.2628 11.5631 16.1996 11.404 16.1996H5.40039ZM2.40039 6.59961C2.40039 5.80396 2.71646 5.0409 3.27907 4.47829C3.84168 3.91568 4.60474 3.59961 5.40039 3.59961H18.6004C19.396 3.59961 20.1591 3.91568 20.7217 4.47829C21.2843 5.0409 21.6004 5.80396 21.6004 6.59961V17.3996C21.6004 18.1953 21.2843 18.9583 20.7217 19.5209C20.1591 20.0835 19.396 20.3996 18.6004 20.3996H5.40039C4.60474 20.3996 3.84168 20.0835 3.27907 19.5209C2.71646 18.9583 2.40039 18.1953 2.40039 17.3996V6.59961ZM5.40039 4.79961C4.923 4.79961 4.46516 4.98925 4.1276 5.32682C3.79003 5.66438 3.60039 6.12222 3.60039 6.59961V17.3996C3.60039 17.877 3.79003 18.3348 4.1276 18.6724C4.46516 19.01 4.923 19.1996 5.40039 19.1996H18.6004C19.0778 19.1996 19.5356 19.01 19.8732 18.6724C20.2107 18.3348 20.4004 17.877 20.4004 17.3996V6.59961C20.4004 6.12222 20.2107 5.66438 19.8732 5.32682C19.5356 4.98925 19.0778 4.79961 18.6004 4.79961H5.40039Z"
                  fill="#1A1A1A"
                />
              </svg>

              <div>
                You need to start by reviewing the Sub CCV Verification Training
                PowerPoint
              </div>
            </div>

            <button>Start Here</button>
          </div>
          <div className="evaluation__main__cards__card evaluation__main__cards__card2">
            <div>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M4.80039 6.59961C4.80039 6.44048 4.86361 6.28787 4.97613 6.17535C5.08865 6.06282 5.24126 5.99961 5.40039 5.99961H18.6004C18.7595 5.99961 18.9121 6.06282 19.0247 6.17535C19.1372 6.28787 19.2004 6.44048 19.2004 6.59961V10.1972C19.2004 10.3563 19.1372 10.509 19.0247 10.6215C18.9121 10.734 18.7595 10.7972 18.6004 10.7972H5.40039C5.24126 10.7972 5.08865 10.734 4.97613 10.6215C4.86361 10.509 4.80039 10.3563 4.80039 10.1972V6.59961ZM6.00039 7.19961V9.59721H18.0004V7.19961H6.00039ZM13.798 11.9996C13.6389 11.9996 13.4862 12.0628 13.3737 12.1753C13.2612 12.2879 13.198 12.4405 13.198 12.5996V17.3996C13.198 17.5587 13.2612 17.7114 13.3737 17.8239C13.4862 17.9364 13.6389 17.9996 13.798 17.9996H18.598C18.7571 17.9996 18.9097 17.9364 19.0223 17.8239C19.1348 17.7114 19.198 17.5587 19.198 17.3996V12.5996C19.198 12.4405 19.1348 12.2879 19.0223 12.1753C18.9097 12.0628 18.7571 11.9996 18.598 11.9996H13.798ZM14.398 16.7996V13.1996H17.998V16.7996H14.398ZM4.80039 13.1996C4.80039 13.0405 4.86361 12.8879 4.97613 12.7753C5.08865 12.6628 5.24126 12.5996 5.40039 12.5996H11.4052C11.5643 12.5996 11.7169 12.6628 11.8295 12.7753C11.942 12.8879 12.0052 13.0405 12.0052 13.1996C12.0052 13.3587 11.942 13.5114 11.8295 13.6239C11.7169 13.7364 11.5643 13.7996 11.4052 13.7996H5.40039C5.24126 13.7996 5.08865 13.7364 4.97613 13.6239C4.86361 13.5114 4.80039 13.3587 4.80039 13.1996ZM5.40039 16.1996C5.24126 16.1996 5.08865 16.2628 4.97613 16.3753C4.86361 16.4879 4.80039 16.6405 4.80039 16.7996C4.80039 16.9587 4.86361 17.1114 4.97613 17.2239C5.08865 17.3364 5.24126 17.3996 5.40039 17.3996H11.404C11.5631 17.3996 11.7157 17.3364 11.8283 17.2239C11.9408 17.1114 12.004 16.9587 12.004 16.7996C12.004 16.6405 11.9408 16.4879 11.8283 16.3753C11.7157 16.2628 11.5631 16.1996 11.404 16.1996H5.40039ZM2.40039 6.59961C2.40039 5.80396 2.71646 5.0409 3.27907 4.47829C3.84168 3.91568 4.60474 3.59961 5.40039 3.59961H18.6004C19.396 3.59961 20.1591 3.91568 20.7217 4.47829C21.2843 5.0409 21.6004 5.80396 21.6004 6.59961V17.3996C21.6004 18.1953 21.2843 18.9583 20.7217 19.5209C20.1591 20.0835 19.396 20.3996 18.6004 20.3996H5.40039C4.60474 20.3996 3.84168 20.0835 3.27907 19.5209C2.71646 18.9583 2.40039 18.1953 2.40039 17.3996V6.59961ZM5.40039 4.79961C4.923 4.79961 4.46516 4.98925 4.1276 5.32682C3.79003 5.66438 3.60039 6.12222 3.60039 6.59961V17.3996C3.60039 17.877 3.79003 18.3348 4.1276 18.6724C4.46516 19.01 4.923 19.1996 5.40039 19.1996H18.6004C19.0778 19.1996 19.5356 19.01 19.8732 18.6724C20.2107 18.3348 20.4004 17.877 20.4004 17.3996V6.59961C20.4004 6.12222 20.2107 5.66438 19.8732 5.32682C19.5356 4.98925 19.0778 4.79961 18.6004 4.79961H5.40039Z"
                  fill="#1A1A1A"
                />
              </svg>

              <div>Take the test to once you’re ready.</div>
            </div>

            <button onClick={getQuestions}>Take Test</button>
          </div>
        </div>
      </div>

      {questionsModal && (
        <div className="evaluation__test">
          <div className="evaluation__test__title">
            You’re about to start your Test
          </div>
          <div className="evaluation__test__subtitle">
            Ensure you’re prepared for the test. We wish you luck!
          </div>
          {questions?.map((item, index) => (
            <div className="evaluation__test__card">
              <div className="evaluation__test__card__question">
                {index + 1}. {item?.question}
              </div>
              <div className="evaluation__test__card__options">
                {item?.options?.map((option) => (
                  <div className="evaluation__test__card__options__option">
                    {item?.selectedOption === option ? (
                      <svg
                        width="18"
                        height="19"
                        viewBox="0 0 26 26"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        style={{ minWidth: 18 }}
                      >
                        <rect
                          x="1"
                          y="1"
                          width="24"
                          height="24"
                          rx="6"
                          stroke="url(#paint0_linear_81_934)"
                          stroke-width="2"
                        />
                        <path
                          d="M7.75 13.75L11.25 17.25L18.25 9.75"
                          stroke="url(#paint1_linear_81_934)"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <defs>
                          <linearGradient
                            id="paint0_linear_81_934"
                            x1="1"
                            y1="1.55078"
                            x2="29.6033"
                            y2="15.6829"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#006633" />
                            <stop offset="1" stop-color="#02A4CC" />
                          </linearGradient>
                          <linearGradient
                            id="paint1_linear_81_934"
                            x1="7.75"
                            y1="9.92212"
                            x2="18.2804"
                            y2="17.206"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#006633" />
                            <stop offset="1" stop-color="#02A4CC" />
                          </linearGradient>
                        </defs>
                      </svg>
                    ) : (
                      <svg
                        width="18"
                        height="19"
                        viewBox="0 0 18 19"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        style={{ minWidth: 18 }}
                        onClick={() => handleSelectOption(option, item)}
                      >
                        <rect
                          x="1"
                          y="1.5"
                          width="16"
                          height="16"
                          rx="3"
                          stroke="url(#paint0_linear_4083_26605)"
                          stroke-width="2"
                        />
                        <defs>
                          <linearGradient
                            id="paint0_linear_4083_26605"
                            x1="1"
                            y1="1.86719"
                            x2="20.0689"
                            y2="11.2886"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#006633" />
                            <stop offset="1" stop-color="#02A4CC" />
                          </linearGradient>
                        </defs>
                      </svg>
                    )}

                    <div>
                      <span></span> {option}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}

          <button
            className="evaluation__test__button"
            onClick={handleSubmitTest}
          >
            Submit
          </button>
        </div>
      )}

      {evaluationDoneModal && (
        <div className="evaluation__done"
        onClick={handleEvaluationModalClose}
        >
          <div className="evaluation__done__inner">
            <svg
              width="221"
              height="199"
              viewBox="0 0 221 199"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle opacity="0.05" cx="115" cy="107" r="92" fill="#605BFF" />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M115.407 73.2109C117.646 95.0439 104.814 104.15 101.178 106.268C101.208 106.494 101.223 106.734 101.223 106.975V138.124L107.203 141.415H138.653C138.713 141.415 138.788 141.415 138.848 141.43C146.091 142.421 146.376 133.856 146.376 132.79C146.331 132.249 146.632 131.708 147.158 131.482C151.696 129.529 149.772 123.398 149.592 122.872C149.352 122.256 149.637 121.55 150.238 121.25C156.128 118.395 152.417 113.256 151.936 112.609C151.545 112.189 151.485 111.543 151.801 111.032C162.469 94.6683 129.141 98.7103 127.008 98.9808C126.842 99.0108 126.662 99.0259 126.482 98.9808C125.776 98.8455 125.325 98.1694 125.46 97.4631C130.434 72.2643 118.969 72.5348 115.377 73.1809L115.407 73.2109Z"
                fill="#605BFF"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M99.0884 138.5V106.975C99.0884 106.224 98.7879 105.548 98.292 105.067C97.7962 104.571 97.12 104.271 96.3837 104.271H79.7047C78.9534 104.271 78.2772 104.571 77.7964 105.067C77.3005 105.563 77 106.239 77 106.975V138.5C77 139.251 77.3005 139.928 77.7964 140.408C78.2922 140.904 78.9684 141.205 79.7047 141.205H96.3837C97.135 141.205 97.8112 140.904 98.292 140.408C98.6978 140.003 98.9682 139.477 99.0584 138.891C99.0584 138.801 99.0584 138.695 99.0884 138.605C99.0884 138.575 99.0884 138.53 99.0884 138.5Z"
                fill="#605BFF"
              />
              <path
                opacity="0.1"
                d="M138.767 7.04776C137.907 6.81226 137.049 6.82176 136.069 6.83263C135.824 6.83535 135.579 6.83807 135.333 6.84078C136.547 5.72466 137.76 4.60854 138.603 3.25149C138.844 2.88126 138.349 2.51918 138.107 2.76691C136.649 3.88575 135.314 5.12573 133.98 6.36571C133.962 4.77316 133.945 3.18061 133.927 1.58805C133.919 0.85303 132.816 0.865255 132.824 1.60028C132.842 3.19283 132.861 4.90789 132.879 6.50044C131.763 5.41013 130.65 4.44232 129.536 3.47452C129.042 3.11244 128.436 3.73175 128.93 4.09383C129.799 5.06435 130.667 6.03487 131.659 7.00404C130.433 7.01762 129.208 7.03121 127.984 7.16729C127.494 7.17273 127.502 7.90775 127.992 7.90232C129.464 8.00852 130.812 7.99358 132.16 7.97864C131.068 8.97089 129.977 10.0857 129.009 11.1991C128.524 11.6945 129.266 12.2989 129.752 11.9259C130.844 10.9337 131.938 10.0639 132.907 9.07302C132.922 10.4206 132.938 11.8906 133.198 13.2354C133.201 13.4804 133.691 13.475 133.811 13.2286C134.043 12.0009 134.028 10.6533 134.013 9.3058C134.383 9.54674 134.632 9.91153 135.002 10.1525C135.745 10.7568 136.487 11.3612 137.227 11.8431C137.475 12.0854 137.839 11.7138 137.591 11.4715C136.97 10.7433 136.472 10.0137 135.851 9.28543C135.478 8.79949 134.983 8.43741 134.612 8.07397C135.224 8.06718 135.715 8.06175 136.327 8.05496C137.308 8.04409 138.043 8.03594 139.021 7.78006C139.142 7.6562 139.136 7.16619 138.767 7.04776Z"
                fill="#030229"
              />
              <path
                opacity="0.1"
                d="M12.011 68.8696C11.1505 68.6341 10.2927 68.6437 9.31233 68.6545C9.06725 68.6572 8.82216 68.66 8.57708 68.6627C9.79027 67.5465 11.0035 66.4304 11.8463 65.0734C12.0873 64.7031 11.5931 64.3411 11.3507 64.5888C9.76855 65.5865 8.43553 66.949 7.10115 68.189C7.0835 66.5964 7.06584 65.0038 7.04819 63.4113C7.04004 62.6763 5.93717 62.6885 5.94532 63.4235C5.96297 65.0161 5.98198 66.7311 5.99964 68.3237C4.88454 67.2334 3.7708 66.2656 2.65707 65.2978C2.16283 64.9357 1.55691 65.555 2.05115 65.9171C2.9198 66.8876 3.78846 67.8581 4.77965 68.8273C3.55424 68.8409 2.32882 68.8544 1.10477 68.9905C0.6146 68.996 0.622748 69.731 1.11291 69.7256C2.58477 69.8318 3.93272 69.8168 5.28068 69.8019C4.18867 70.7941 3.09802 71.9089 2.12991 73.0223C1.64518 73.5177 2.38722 74.1221 2.87331 73.7492C3.96532 72.7569 5.05868 71.8872 6.02815 70.8963C6.04309 72.2438 6.05939 73.7139 6.31941 75.0587C6.32212 75.3037 6.81229 75.2983 6.93211 75.0519C7.16362 73.8241 7.14868 72.4766 7.13374 71.129C7.50408 71.37 7.75324 71.7348 8.12358 71.9757C8.86562 72.5801 9.60766 73.1844 10.3483 73.6663C10.5961 73.9086 10.9597 73.537 10.7119 73.2947C10.091 72.5665 9.59272 71.8369 8.97186 71.1087C8.59881 70.6227 8.10457 70.2607 7.73287 69.8972C8.34558 69.8904 8.83574 69.885 9.44845 69.8782C10.4288 69.8673 11.164 69.8592 12.1416 69.6033C12.2628 69.4794 12.2574 68.9894 12.011 68.8696Z"
                fill="#030229"
              />
              <path
                d="M32.6416 28.3324C31.2855 27.6123 30.0519 26.8909 29.058 25.6767C27.9402 24.3414 27.4324 22.7543 26.6795 21.1699C26.6795 21.1699 26.6781 21.0474 26.5556 21.0488L26.433 21.0501C26.433 21.0501 26.433 21.0501 26.3118 21.174C26.3118 21.174 26.3118 21.174 26.3132 21.2965C25.9822 24.6082 24.0474 26.9575 21.6196 29.0672C21.4984 29.1911 21.5012 29.4361 21.6251 29.5572C24.3346 30.7524 26.2093 34.0396 27.097 36.7252C27.2223 36.9688 27.5899 36.9648 27.7097 36.7184C28.1822 35.1204 28.5336 33.6463 29.375 32.1667C30.2165 30.6872 31.3072 29.5724 32.6456 28.6999C32.7668 28.5761 32.7641 28.3311 32.6416 28.3324Z"
                fill="#605BFF"
              />
              <path
                d="M219.894 65.0809C218.538 64.3608 217.304 63.6393 216.433 62.4238C215.315 61.0885 214.807 59.5014 214.054 57.917C214.054 57.917 214.053 57.7945 213.931 57.7958L213.808 57.7972C213.808 57.7972 213.808 57.7972 213.687 57.921C213.687 57.921 213.687 57.921 213.688 58.0435C213.357 61.3552 211.422 63.7045 208.995 65.8143C208.873 65.9381 208.876 66.1831 209 66.3043C211.71 67.4994 213.584 70.7867 214.472 73.4723C214.597 73.7159 214.965 73.7118 215.085 73.4655C215.557 71.8675 215.909 70.3934 216.75 68.9138C217.592 67.4342 218.682 66.3195 220.021 65.447C220.021 65.447 220.018 65.202 219.894 65.0809Z"
                fill="#605BFF"
              />
              <path
                d="M130.094 34.9566C129.109 34.4774 128.368 33.9956 127.623 33.1462C126.877 32.1743 126.497 31.0758 125.872 29.9801C125.872 29.9801 125.872 29.9801 125.75 29.9815L125.627 29.9828C125.627 29.9828 125.627 29.9828 125.628 30.1053C125.409 32.4356 124.079 34.0431 122.38 35.5322C122.258 35.656 122.26 35.7785 122.382 35.7772C124.352 36.613 125.604 38.927 126.237 40.7577C126.239 41.0027 126.607 40.9987 126.604 40.7537C126.837 39.6484 127.193 38.5418 127.794 37.555C128.396 36.5681 129.123 35.825 130.097 35.2016C130.22 35.2002 130.217 34.9552 130.094 34.9566Z"
                fill="#605BFF"
              />
              <path
                d="M98.839 56.8049C97.1139 55.9664 95.7565 55.1238 94.6373 53.666C93.2703 51.9659 92.6373 50.1351 91.7578 48.1846C91.7578 48.1846 91.7564 48.062 91.6338 48.0634L91.5113 48.0648C91.5113 48.0648 91.3888 48.0661 91.3901 48.1886L91.3915 48.3111C90.9448 52.2367 88.6491 55.2026 85.7352 57.6853C85.6141 57.8091 85.6181 58.1766 85.8632 58.1739C89.1881 59.6073 91.4373 63.503 92.4543 66.7997C92.5809 67.1659 93.0711 67.1604 93.1896 66.7916C93.6594 64.9486 94.2517 63.1042 95.213 61.3783C96.1743 59.6524 97.5074 58.2899 99.2121 57.2908C98.967 57.2936 99.0855 56.9247 98.839 56.8049Z"
                fill="#605BFF"
              />
              <path
                d="M69.4523 25.9507C67.7096 23.5196 65.9682 21.211 63.7407 19.2754C62.5044 18.309 61.2681 17.3425 59.912 16.6225C59.1727 16.2631 58.4348 16.0262 57.6954 15.6669C57.3264 15.5484 56.9575 15.43 56.5871 15.1891C56.2181 15.0707 55.9703 14.8284 55.6041 14.9549C55.359 14.9577 55.2378 15.0815 55.3631 15.3252C55.4924 15.9363 56.2317 16.2957 56.726 16.6578C57.3441 17.141 57.9609 17.5017 58.579 17.9849C59.8139 18.8289 61.0502 19.7953 62.164 20.7631C64.2689 22.7001 66.0076 24.7637 67.6264 27.0736C68.3739 28.168 70.2011 27.1676 69.4523 25.9507Z"
                fill="#FF8F6B"
              />
              <path
                d="M68.5789 75.1029C67.5728 72.7862 65.2309 71.587 62.8918 70.6327C60.5526 69.6785 57.8472 68.8509 55.4004 69.2456C53.0749 69.5164 50.5178 71.0149 49.6845 73.2295C49.0894 74.8289 48.5025 77.1632 49.9866 78.372C50.73 79.0988 52.0793 79.2064 52.8064 78.4632C54.0196 77.3471 52.8977 75.6443 51.9079 74.7976C47.8232 71.1673 40.9677 71.8559 36.4568 73.9887C33.6519 75.245 31.2241 77.3548 29.7849 80.1887C28.5839 82.4073 27.2794 86.3424 28.8983 88.6523C29.1474 89.0171 29.6376 89.0117 29.8786 88.6414C31.2062 86.7889 31.1763 84.0938 32.1349 82.1229C33.0921 80.0295 34.6662 78.2968 36.4921 77.1738C40.2637 74.6817 46.7448 73.3846 50.696 76.0363C51.1903 76.3983 52.5477 77.2409 51.8206 77.9841C51.2147 78.6034 50.2276 78.0017 49.8545 77.5158C48.3542 74.837 51.8753 71.8575 54.0742 71.2206C56.2732 70.5836 58.8533 71.1676 60.946 72.002C63.2825 72.7112 65.9933 74.0289 67.363 75.974C67.9784 76.2122 68.8308 75.7127 68.5789 75.1029Z"
                fill="#EF37FF"
              />
              <path
                d="M176.16 55.642C176.282 55.6406 176.281 55.5181 176.158 55.5195C176.036 55.5208 176.037 55.6433 176.16 55.642Z"
                fill="#3F3937"
              />
              <path
                d="M177.24 53.5469C179.28 49.6037 183.523 45.391 188.318 46.8081C190.039 47.2791 192.263 48.8472 192.042 51.055C191.936 52.5264 190.209 51.5654 189.59 50.9596C188.102 49.3834 188.806 46.5576 189.275 44.7146C189.983 42.2564 191.551 39.9112 193.618 38.418C195.318 37.0515 197.64 36.4132 199.72 36.1451C202.046 35.8742 204.137 36.5862 206.348 37.0517C207.207 37.1647 207.809 36.1779 207.19 35.5722C205.578 33.8748 202.757 33.661 200.554 33.9305C198.228 34.2013 195.784 34.841 193.838 36.2103C189.945 38.8263 187.066 44.3716 187.485 49.0227C187.753 51.1025 190.492 54.9927 192.796 52.7619C193.888 51.7696 193.5 49.9361 192.996 48.7165C192.118 46.8885 190.144 45.6852 188.3 45.2155C182.77 43.8066 178.532 48.5093 176.501 53.1875C176.382 53.5564 176.999 53.9171 177.24 53.5469Z"
                fill="#EF37FF"
              />
              <path
                d="M71.2249 48.4867C69.4821 46.0557 67.256 44.2426 64.6691 43.0461C63.3143 42.4485 61.9609 41.9734 60.6103 41.7433C59.3821 41.5119 57.5426 41.4098 56.4466 42.0345C56.2028 42.1597 56.2069 42.5273 56.4547 42.7695C57.4418 43.3712 58.9137 43.4774 60.0193 43.7102C61.3713 44.0628 62.4783 44.418 63.7105 45.017C66.051 46.0937 68.2744 47.6618 69.8891 49.6042C70.51 50.3325 71.8471 49.3375 71.2249 48.4867Z"
                fill="#FF8F6B"
              />
              <path
                d="M43.2557 57.0061C44.3558 56.7489 45.5799 56.6128 46.6828 56.6006C47.2955 56.5938 47.9082 56.587 48.5209 56.5802C48.8885 56.5761 49.2561 56.5721 49.4999 56.4469C49.7436 56.3216 49.9887 56.3189 50.2324 56.1937C50.4761 56.0685 50.472 55.701 50.2256 55.5812C49.9792 55.4614 49.7327 55.3416 49.6088 55.2205C49.3624 55.1007 48.8722 55.1061 48.6258 54.9863C48.0131 54.9931 47.4004 54.9999 46.6665 55.1305C45.4424 55.2666 44.2197 55.5252 42.9984 55.9063C42.2645 56.037 42.5218 57.1368 43.2557 57.0061Z"
                fill="#FF8F6B"
              />
              <path
                d="M173.803 86.1759C177.211 84.0553 180.868 82.2995 184.777 81.1535C186.61 80.6431 188.565 80.1313 190.523 79.8646C191.625 79.7299 192.604 79.5965 193.705 79.4618C194.563 79.4523 195.421 79.4427 196.152 79.0671C196.396 78.9419 196.392 78.5744 196.145 78.4546C195.283 78.0966 194.427 78.2286 193.447 78.2394C192.344 78.2517 191.365 78.385 190.262 78.3973C188.18 78.5429 186.101 78.9335 184.023 79.4466C179.868 80.4728 176.212 82.3511 172.81 85.0842C172.326 85.5797 173.072 86.5516 173.803 86.1759Z"
                fill="#FF8F6B"
              />
              <path
                d="M166.999 80.4926C169.906 77.3974 173.682 75.2727 177.335 73.1494C179.162 72.149 181.111 71.0247 183.062 70.1454C184.159 69.6432 185.134 69.1423 186.109 68.6414C187.084 68.1405 188.184 67.8833 189.158 67.2599C189.402 67.1347 189.397 66.7672 189.028 66.6488C188.045 66.4146 186.947 66.7944 185.968 66.9277C184.744 67.0638 183.645 67.4436 182.547 67.9458C180.352 68.9503 178.159 70.0773 176.089 71.3254C172.07 73.5753 168.542 75.9423 165.764 79.6486C165.281 80.2666 166.392 80.9894 166.999 80.4926Z"
                fill="#FF8F6B"
              />
              <path
                d="M146.87 22.5192C146.744 22.153 146.739 21.7855 146.611 21.2969C146.609 21.0518 146.485 20.9307 146.483 20.8082C146.482 20.6857 146.481 20.5632 146.357 20.442C146.356 20.3195 146.233 20.3209 146.232 20.1984C146.108 20.0772 145.984 19.9561 145.861 19.9575C145.739 19.9588 145.618 20.0827 145.496 20.2065C145.498 20.329 145.375 20.3304 145.377 20.4529C145.378 20.5754 145.379 20.6979 145.381 20.8204C145.383 21.0654 145.386 21.3104 145.511 21.5541C145.515 21.9216 145.642 22.2877 145.769 22.6539L145.767 22.5314L145.769 22.6539C145.77 22.7764 145.895 23.0201 146.019 23.1412C146.143 23.2623 146.389 23.3821 146.511 23.2583C146.633 23.2569 146.877 23.1317 146.876 23.0092C146.876 23.0092 146.873 22.7642 146.87 22.5192Z"
                fill="#030229"
              />
              <path
                d="M151.967 40.1051C152.054 36.9187 153.003 34.0902 154.074 31.1379C154.67 29.6611 155.268 28.3067 155.988 26.951C156.708 25.5953 157.431 24.4847 157.783 23.0105C157.78 22.7655 157.531 22.4007 157.289 22.6485C156.681 23.1453 156.318 23.5168 155.834 24.1348C155.474 24.7514 155.114 25.4905 154.753 26.1071C154.034 27.5853 153.315 29.0635 152.72 30.6628C151.65 33.6151 151.074 36.9295 150.987 40.116C151.116 40.7272 151.974 40.7177 151.967 40.1051Z"
                fill="#FF8F6B"
              />
              <path
                d="M162.277 19.4083C162.397 19.1619 162.518 19.038 162.638 18.7917C162.638 18.7917 162.639 18.9142 162.517 18.9155C162.517 18.9155 162.516 18.793 162.638 18.7917L162.759 18.6678C162.88 18.5439 162.88 18.5439 163.002 18.4201C163.243 18.0499 163.608 17.8008 163.849 17.4305C164.09 17.0603 164.455 16.8112 164.696 16.441C164.815 16.1946 165.059 16.0694 165.179 15.823C165.178 15.7005 165.3 15.6992 165.299 15.5767C165.42 15.4528 165.419 15.3303 165.417 15.2078C165.537 14.9614 165.288 14.5967 164.92 14.6007C164.798 14.6021 164.675 14.6034 164.43 14.6062C164.308 14.6075 164.309 14.73 164.186 14.7314C164.186 14.7314 164.186 14.7314 164.064 14.7327C164.186 14.7314 164.186 14.7314 164.064 14.7327C163.819 14.7355 163.576 14.9832 163.333 15.1084C162.845 15.3588 162.482 15.7304 162.118 16.102C161.755 16.4736 161.391 16.8452 161.151 17.3379C160.91 17.7082 160.548 18.2022 160.43 18.5711C160.189 18.9413 160.318 19.5525 160.811 19.7921C161.547 19.9064 162.036 19.7785 162.277 19.4083Z"
                fill="#FF8F6B"
              />
              <path
                d="M158.243 42.3637C158.6 41.3796 159.08 40.5167 159.437 39.5326C159.794 38.5485 160.152 37.6869 160.631 36.7014C161.112 35.8384 161.469 34.8543 161.949 33.9914C162.43 33.1284 163.156 32.2627 163.267 31.2813C163.263 30.9138 162.894 30.7954 162.649 30.7981C161.672 31.054 161.194 32.162 160.589 32.9038C159.863 33.7695 159.384 34.7549 158.905 35.7404C158.426 36.7258 158.069 37.71 157.713 38.8166C157.596 39.3079 157.357 39.8007 157.363 40.4132C157.246 40.9046 157.253 41.5171 157.259 42.0071C157.143 42.621 158.003 42.8565 158.243 42.3637Z"
                fill="#FF8F6B"
              />
              <path
                d="M164.956 28.9351C165.194 28.3199 165.556 27.8258 165.919 27.3317C166.401 26.5912 166.636 25.731 167.119 25.113C167.603 24.4951 168.213 24.2433 168.82 23.7465C169.427 23.2497 170.035 22.7529 170.641 22.1336C172.944 19.9027 175.619 17.9127 178.419 16.2889C179.151 15.9133 179.882 15.5376 180.613 15.1619C181.1 14.9115 181.83 14.4133 181.456 13.8049C180.83 12.5866 178.396 14.2064 177.665 14.582C174.864 16.2058 172.562 18.5592 170.012 20.6703C169.282 21.1685 168.676 21.7878 168.07 22.4071C167.464 23.0264 166.983 23.8894 166.377 24.5087C165.772 25.128 165.04 25.5036 164.434 26.123C163.95 26.6184 163.59 27.3575 163.353 28.0952C162.874 29.0807 164.355 30.0444 164.956 28.9351Z"
                fill="#FF8F6B"
              />
              <path
                opacity="0.5"
                d="M106.944 36.0711C107.424 35.0856 107.533 33.8592 107.398 32.7581C107.384 31.533 107.248 30.3093 106.991 29.2095C106.988 28.9645 106.498 28.9699 106.501 29.2149C106.39 30.3188 106.403 31.4214 106.416 32.6464C106.427 33.6264 106.439 34.729 106.081 35.5906C105.843 36.2058 106.706 36.6863 106.944 36.0711Z"
                fill="#EF37FF"
              />
              <g opacity="0.5">
                <path
                  d="M107.013 20.1434C107.001 19.0409 107.111 17.937 106.978 16.9583C106.843 15.8571 106.465 14.8812 105.841 13.908C105.716 13.6643 105.227 13.7922 105.354 14.1584C105.866 16.113 105.889 18.1956 105.912 20.2782C105.796 20.892 107.021 20.8785 107.013 20.1434Z"
                  fill="#EF37FF"
                />
              </g>
              <path
                opacity="0.5"
                d="M101.503 9.66716C101.247 8.68985 100.869 7.71389 100.369 6.8618C100.12 6.497 99.9919 6.00835 99.7427 5.64355C99.4936 5.27876 99.2403 4.54645 98.7502 4.55188C98.5051 4.5546 98.26 4.55732 98.1402 4.80368C97.9005 5.29641 98.2736 5.78236 98.5241 6.26965C98.7733 6.63445 99.0238 7.12175 99.1504 7.4879C99.6501 8.34 100.027 9.19345 100.282 10.0483C100.535 10.7806 101.756 10.3995 101.503 9.66716Z"
                fill="#EF37FF"
              />
              <path
                opacity="0.5"
                d="M107.122 7.88985C107.357 6.90711 107.467 5.80321 107.577 4.69932C107.572 4.2093 107.565 3.59678 107.56 3.10677C107.554 2.61675 107.547 2.00423 107.297 1.51693C107.17 1.15078 106.68 1.15621 106.562 1.52508C106.322 2.01782 106.329 2.63034 106.334 3.12035C106.34 3.61037 106.345 4.10038 106.35 4.5904C106.361 5.57043 106.25 6.55182 106.138 7.53321C106.141 7.77822 106.267 8.14437 106.512 8.14165C106.76 8.38395 107.126 8.25737 107.122 7.88985Z"
                fill="#EF37FF"
              />
              <path
                opacity="0.5"
                d="M111.818 11.391C112.049 10.1632 112.527 9.05526 113.129 8.06843C113.731 7.08161 114.579 6.21457 115.304 5.22639C115.423 4.98003 115.297 4.61387 115.053 4.73909C113.709 5.12155 112.741 6.23495 112.141 7.34428C111.418 8.45496 111.065 9.80658 110.833 11.0343C110.597 11.7721 111.703 12.1274 111.818 11.391Z"
                fill="#EF37FF"
              />
              <path
                d="M192.87 59.5005C192.991 59.3766 192.99 59.2541 193.111 59.1302C193.231 58.8839 193.351 58.6375 193.348 58.3925C193.345 58.1475 193.344 58.025 193.464 57.7786L193.462 57.6561C193.461 57.5336 193.459 57.4111 193.458 57.2886C193.455 57.0436 193.453 56.7986 193.327 56.5549C193.325 56.3099 193.201 56.1888 193.077 56.0676C192.826 55.5803 192.332 55.2182 191.718 55.1025C191.965 55.2223 192.211 55.3421 192.459 55.5844C192.211 55.3421 191.965 55.2223 191.719 55.225C191.473 55.1053 191.228 55.108 191.107 55.2318C190.862 55.2345 190.74 55.3584 190.497 55.4836C190.253 55.6089 190.011 55.8566 189.891 56.1029C190.256 55.8539 190.498 55.6061 190.863 55.3571C190.74 55.3584 190.619 55.4823 190.497 55.4836C190.253 55.6089 190.009 55.7341 189.888 55.8579C189.767 55.9818 189.646 56.1057 189.525 56.2295C189.526 56.352 189.403 56.3534 189.405 56.4759C189.406 56.5984 189.285 56.7223 189.286 56.8448C189.407 56.7209 189.405 56.4759 189.526 56.352C189.527 56.4745 189.405 56.4759 189.406 56.5984C189.407 56.7209 189.285 56.7223 189.286 56.8448C189.165 56.9686 189.168 57.2136 189.047 57.3375C188.927 57.5839 188.807 57.8302 188.811 58.1977C188.691 58.4441 188.818 58.8103 188.821 59.0553C188.946 59.2989 189.071 59.5426 189.196 59.7862C189.322 60.0299 189.569 60.2722 189.816 60.3919C189.94 60.5131 190.185 60.5104 190.309 60.6315C190.678 60.7499 191.168 60.7445 191.534 60.6179C191.655 60.4941 191.9 60.4914 192.022 60.3675C192.509 60.117 192.75 59.7468 192.87 59.5005Z"
                fill="#FF8F6B"
              />
              <path
                d="M187.988 17.0395C187.986 16.917 187.864 16.9184 187.862 16.7959C187.739 16.6747 187.615 16.5536 187.613 16.4311C187.613 16.4311 187.489 16.31 187.367 16.3113C187.12 16.1915 187.119 16.069 186.75 15.9506C186.628 15.952 186.381 15.8322 186.259 15.8335C186.136 15.8349 185.891 15.8376 185.891 15.8376L185.525 15.9642C185.281 16.0894 185.16 16.2133 185.04 16.4596C184.919 16.5835 184.919 16.5835 184.92 16.706C184.921 16.8285 184.799 16.8299 184.8 16.9524C184.68 17.1987 184.562 17.5676 184.566 17.9351C184.57 18.3026 184.695 18.5463 184.822 18.9124C185.196 19.5209 185.813 19.8816 186.426 19.8748C187.039 19.868 187.77 19.4923 188.008 18.8771C188.128 18.6307 188.246 18.2619 188.242 17.8944C188.24 17.6493 188.114 17.4057 187.988 17.0395Z"
                fill="#FF8F6B"
              />
              <path
                d="M97.8371 32.7421C96.8201 29.4454 97.2709 25.8874 97.8469 22.573C97.8442 22.3279 97.5977 22.2082 97.4779 22.4545C96.2892 25.7757 95.9636 29.5774 96.982 32.9967C96.9888 33.6092 97.9664 33.3533 97.8371 32.7421Z"
                fill="#030229"
              />
            </svg>

            <div className="evaluation__done__inner__title">
              Congrats! You did it!
            </div>
            <div className="evaluation__done__inner__subtitle">
              You can now begin verifying carbon emission data of different
              facility
            </div>

            <button
              className="evaluation__done__inner__button"
              onClick={() => navigate("/third-party/verification")}
            >
              <div>Begin your verification journey</div>
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
